import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {withTranslation} from 'react-i18next';
import './ClientProfileForm.scss';

export const BUSINESS_TYPE_OPTIONS = [
    {value: 'ECOMMERCE', labelKey: 'client_profile.business_type_ecommerce'},
    {value: 'LEAD_GEN', labelKey: 'client_profile.business_type_lead_gen'},
    {value: 'BRAND_AWARENESS', labelKey: 'client_profile.business_type_brand_awareness'},
    {value: 'APP_INSTALL', labelKey: 'client_profile.business_type_app_install'},
    {value: 'OTHER', labelKey: 'client_profile.business_type_other'},
];

export const INDUSTRY_OPTIONS = [
    {value: 'RETAIL', labelKey: 'client_profile.industry_retail'},
    {value: 'TECHNOLOGY', labelKey: 'client_profile.industry_technology'},
    {value: 'FINANCE', labelKey: 'client_profile.industry_finance'},
    {value: 'HEALTHCARE', labelKey: 'client_profile.industry_healthcare'},
    {value: 'EDUCATION', labelKey: 'client_profile.industry_education'},
    {value: 'SERVICES', labelKey: 'client_profile.industry_services'},
    {value: 'FOOD_BEVERAGE', labelKey: 'client_profile.industry_food_beverage'},
    {value: 'REAL_ESTATE', labelKey: 'client_profile.industry_real_estate'},
    {value: 'OTHER', labelKey: 'client_profile.industry_other'},
];

class ClientProfileFormClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            savingChanges: false,
            moduleAgentEnabled: false,
            business_type: '',
            industry: '',
            primary_kpi: '',
            notes: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getProfileData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.clientId !== this.props.clientId) {
            this.setState({loading: true});
            this.getProfileData();
        }
    }

    getProfileData() {
        const {clientId} = this.props;
        if (!clientId) {
            this.setState({loading: false});
            return;
        }

        new APIClient(API_URL + 'client/' + clientId + '/profile').call('GET').then((data) => {
            if (data.status === 'OK') {
                this.setState({
                    loading: false,
                    moduleAgentEnabled: data.data.module_agent_enabled,
                    business_type: data.data.business_type || '',
                    industry: data.data.industry || '',
                    primary_kpi: data.data.primary_kpi || '',
                    notes: data.data.notes || '',
                });
            } else {
                this.setState({loading: false});
                alert(data['error_message']);
            }
        });
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    handleSubmit() {
        const {t, clientId, onSuccess} = this.props;
        this.setState({savingChanges: true});
        new APIClient(API_URL + 'client/' + clientId + '/profile').call('PUT', {
            business_type: this.state.business_type || null,
            industry: this.state.industry || null,
            primary_kpi: this.state.primary_kpi || null,
            notes: this.state.notes || null,
        }).then((data) => {
            this.setState({savingChanges: false});
            if (data.status === 'OK') {
                alert(t('client_profile.save_success'));
                onSuccess && onSuccess();
            } else {
                alert(data['error_message']);
            }
        });
    }

    renderSaveButton() {
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        }
        return <SubmitButton onClick={this.handleSubmit} value={this.props.t('client_profile.save')}/>;
    }

    render() {
        const {t, onCancel, showCancelButton} = this.props;

        if (this.state.loading) {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            );
        }

        const disabled = !this.state.moduleAgentEnabled;

        return (
            <div className="client-profile-form">
                {this.state.moduleAgentEnabled && (
                    <p className="client-profile-form-explanation">
                        {t('client_profile.agent_explanation')}
                    </p>
                )}
                {!this.state.moduleAgentEnabled && (
                    <div className="form-row">
                        <div className="alert alert-info">
                            {t('client_profile.not_access_message')}
                        </div>
                    </div>
                )}

                <div className="form-row">
                    <label>{t('client_profile.business_type')}:</label>
                    <select name="business_type" value={this.state.business_type}
                            onChange={this.handleChange} disabled={disabled}>
                        <option value="">{t('client_profile.select_option')}</option>
                        {BUSINESS_TYPE_OPTIONS.map(opt => (
                            <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
                        ))}
                    </select>
                </div>

                <div className="form-row">
                    <label>{t('client_profile.industry')}:</label>
                    <select name="industry" value={this.state.industry}
                            onChange={this.handleChange} disabled={disabled}>
                        <option value="">{t('client_profile.select_option')}</option>
                        {INDUSTRY_OPTIONS.map(opt => (
                            <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
                        ))}
                    </select>
                </div>

                <div className="form-row">
                    <label>{t('client_profile.primary_kpi')}:</label>
                    <input type="text" name="primary_kpi" value={this.state.primary_kpi}
                           onChange={this.handleChange} disabled={disabled}/>
                </div>

                <div className="form-row">
                    <label>{t('client_profile.notes')}:</label>
                    <textarea name="notes" value={this.state.notes}
                              onChange={this.handleChange} disabled={disabled}
                              placeholder={t('client_profile.notes_placeholder')}
                              rows={3}/>
                </div>

                {this.state.moduleAgentEnabled && (
                    <div className="submit-row client-profile-form-actions">
                        {showCancelButton && onCancel && (
                            <button type="button" className="btn -negative" onClick={onCancel}>
                                {t('client_reports.cancel')}
                            </button>
                        )}
                        {this.renderSaveButton()}
                    </div>
                )}
            </div>
        );
    }
}

export const ClientProfileForm = withTranslation()(ClientProfileFormClass);
